import Modal from '@Components/Shared/Modals/Modal';
import WebSavedSearchesList from '@Components/WebSavedSearches/WebSavedSearchesList';
import translator from '@Components/Utilities/Translator';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const WebSavedSearchesModal = (props) => {
    const windowSize = useWindowSize();

    const onClose = () => {
        props?.onClose?.();
    };

    return (
        <Modal containerClassName='buyers-premium-modal' contentClassName={windowSize.isMobile ? 'mobile-saved-searches' : ''} onEscapeKeyClose={onClose}>
            <Modal.Header onClose={onClose}>
                <Modal.Title>
                    {translator.translate('sandhills.savedsearches')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p id='description-label' className='hidden'>Add and view saved searches</p>
                <WebSavedSearchesList {...props} onClose={onClose} />
            </Modal.Body>
        </Modal>
    );
};

export default WebSavedSearchesModal;